var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 36 36)",
    id: "589d01a9-54ac-49fe-8069-0f79418adbdd"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -36,
    y: -36,
    rx: 0,
    ry: 0,
    width: 72,
    height: 72
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(Infinity NaN NaN Infinity 0 0)",
    id: "679aee28-1b31-4ebf-856d-ba9a284511d2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 36 36)",
    id: "13b37f46-eec6-4a4b-a48b-a78c7835c72c"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-25.5, -21.5)",
    d: "M 21.5404 0 C 22.0683 1.61049 22.3323 2.95256 22.3323 4.02622 C 22.3323 4.99252 22.1739 6.2809 21.8571 7.89139 C 14.7826 7.89139 11.2453 11.5955 11.2453 19.0037 C 11.2453 21.6879 12.618 23.191 15.3634 23.5131 C 19.3758 23.8352 21.382 26.4657 21.382 31.4045 C 21.382 35.1623 20.4845 38.0612 18.6894 40.1011 C 17 42.0337 13.8851 43 9.34472 43 C 3.11491 43 0 38.7054 0 30.1161 C 0 21.5268 1.68944 14.387 5.06832 8.69663 C 8.44721 2.89888 13.9379 0 21.5404 0 Z M 50.2081 0 C 50.736 1.61049 51 2.95256 51 4.02622 C 51 4.99252 50.8416 6.2809 50.5248 7.89139 C 43.4503 7.89139 39.913 11.5955 39.913 19.0037 C 39.913 21.6879 41.2857 23.191 44.0311 23.5131 C 48.0435 23.8352 50.0497 26.4657 50.0497 31.4045 C 50.0497 35.1623 49.1522 38.0612 47.3571 40.1011 C 45.6677 42.0337 42.5528 43 38.0124 43 C 31.7826 43 28.6677 38.7054 28.6677 30.1161 C 28.6677 21.5268 30.3571 14.387 33.736 8.69663 C 37.1149 2.89888 42.6056 0 50.2081 0 Z",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.ed90f1d837195f9e7934014e0bd201e8.svg";
export { ForwardRef as ReactComponent };